import { combineReducers } from 'redux'

import entidades from './store'
import consultaListaIndicadoresPlanejamentoEstrategico from './consultaListaIndicadoresPlanejamentoEstrategico/store'

export default combineReducers({
    entidades,
    consultaListaIndicadoresPlanejamentoEstrategico,
})
